import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import {
  TableRowAction,
  TableRowActionsModel,
} from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ClaimsService } from '../../../../services/claims.service';

@Component({
  selector: 'ppl-search-add-diagnosis-code',
  standalone: true,
  imports: [
    ButtonComponent,
    ListTableComponent,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
  ],
  templateUrl: './search-add-diagnosis-code.component.html',
  styleUrl: './search-add-diagnosis-code.component.css',
})
export class SearchAddDiagnosisCodeComponent implements OnInit {
  diagnosisData: any = null;
  cols = [
    {
      field: 'code',
      header: 'Code',
      jsonpath: 'code',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'description',
      header: 'Description',
      jsonpath: 'description',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  searchParam = '';
  actionButtons: TableRowActionsModel = new TableRowActions({ select: true });
  searchDiagnosisForm!: FormGroup;
  errorMsg: any;
  @Input() control: any;
  @Output() diagnosisCodeSelected = new EventEmitter();

  constructor(private fb: FormBuilder, private claimsService: ClaimsService) {}

  ngOnInit(): void {
    this.searchDiagnosisForm = this.fb.group({
      code: [null],
      description: [null],
    });
  }

  onSearch() {
    this.errorMsg = '';
    this.diagnosisData = null;
    const code = this.searchDiagnosisForm.value?.code?.trim();
    const desc = this.searchDiagnosisForm.value?.description?.trim();

    if (!code && !desc) {
      this.errorMsg = 'Please enter a value for either code or description.';
      return;
    } else if (
      (!desc && code && code.length < 3) ||
      (!code && desc && desc.length < 3)
    ) {
      this.errorMsg = 'Please enter at least 3 characters to search.';
      return;
    } else if (desc && desc.length < 3 && code && code.length < 3) {
      this.errorMsg = 'Please enter at least 3 characters to search.';
      return;
    } else {
      const payload = {
        programCode: 'NY',
        code: code,
        description: desc,
      };

      this.claimsService.getDiagnosisCode(payload).subscribe((data: any) => {
        if (data.status == 200) {
          if (data.responsedata) {
            this.diagnosisData = data.responsedata.map((item: any) => ({
              ...item,
                arialabel: `'Code': ${item.code} - 'Description' : ${item.description}`
            }));
          } else {
            this.diagnosisData = [];
          }
        }
      });
    }
  }

  onCancel() {}

  onAction(event: any) {
    if (event.action === 'select') {
      this.diagnosisCodeSelected.emit({
        control: this.control,
        code: event.data,
      });
    }
  }
}
